<template>



  <section class="section animated" :class="animation">
    <span class="line">{{ post.created }}</span>
    <div class="columns  post">
       <touch-ripple :speed="1" :opacity="0.1" color="#8c61dc" transition="ease">
      <div class="column is-3 is-center">
        <figure class="image img-shawod">
          <img src="../assets/blog.jpg">
        </figure>
      </div>
      <div class="column">
        <div class="columns title-undeline">
          <h2 class="is-size-3">{{ post.title }}</h2>
        </div>
        <div class="columns" v-html="post.short_description">
          {{ post.short_description }}
        </div>
        <div class="columns tags is-marginless">
          <!-- <ul>
            <li> <i class="fa fa-tag"></i>vue</li>
            <li> <i class="fa fa-tag"></i>vue</li>
            <li> <i class="fa fa-tag"></i>vue</li>
          </ul> -->
        </div>
      </div>
      <!-- <i class="underline"></i> -->
      </touch-ripple>
      </div>
  </section>
</template>

<script>

export default {
  name: 'BlogPost',
  props : ['post'],
  mounted () {
    //change it dynamicaly after real data
    // this.animation = 'slideInLeft'

  },
  data () {
    return {
      animation : ""
    }
  },
}
</script>

<style lang="scss">
@import '../../static/_variables.scss';
@import '../../static/styles.scss';


.tags{
  ul li {
    float: left;
    margin-left: 1em;
  }
}
.post{
  transition: all 1s;
  padding: 1em;
  border-radius: 0.5em;
  -webkit-box-shadow: 0px 0px 12px 3px rgba(0,0,0,0.41);
  -moz-box-shadow: 0px 0px 12px 3px rgba(0,0,0,0.41);
  box-shadow: 0px 0px 12px 3px rgba(0,0,0,0.41);
}
.post:hover{
  cursor: pointer;
}

.title-undeline{
  border-bottom: 5px solid $stipe-color;
  margin-bottom: 2em;
}

</style>



// WEBPACK FOOTER //
// src/componests/BlogPost.vue